import { render, staticRenderFns } from "./cashDisbursement.vue?vue&type=template&id=4801db0b&scoped=true&"
import script from "./cashDisbursement.vue?vue&type=script&lang=js&"
export * from "./cashDisbursement.vue?vue&type=script&lang=js&"
import style0 from "./cashDisbursement.vue?vue&type=style&index=0&id=4801db0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801db0b",
  null
  
)

export default component.exports